import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { PREVIEW, PRODUCTION, generateSurfaceUrl } from '../utils/environments';
import { snakeCaseToTitleCase } from '../utils/api_utils';
import CustomLoader from '../../features/common/CustomLoader';
import ToggleButton from './ToggleButton';
import Swal from 'sweetalert2';
import voca from 'voca';

const PreviewProjectModal = ({
  projectId,
  projectDetail,
  versions,
  selVersion,
  popoverOpen,
  toggle,
  isPreviewPublishing,
  handleVersionChange,
  publishApp,
  actions,
  version,
}) => {
  const [debugModeState, setDebugModeState] = useState({});
  let { domainName, uuid, seoName, projectType, debugMode } = projectDetail;
  useEffect(() => {
    const initialState = {};
    if (debugMode) {
      initialState[PREVIEW] = { isEnable: debugMode.includes(PREVIEW), environment: PREVIEW };
    }
    setDebugModeState(initialState);
  }, [debugMode]);
  let url = generateSurfaceUrl(PREVIEW, seoName);

  const generateProjectURL = (domainName, seoName) => {
    return (
      <>
        <i className="wb webconnect-box-arrow-in-up-right" title="Open link in new tab"></i>
        <a
          className="icon-link"
          style={{ color: '#1F2041' }}
          href={url}
          target="_blank"
          title="Open link in new tab"
        >
          {url}
        </a>
      </>
    );
  };

  const handlePublishClick = async () => {
    try {
      const res = await publishApp(PREVIEW, 'Preview');
      if (res && res.success) {
        console.log('App published in Preview successfully!');
        // setTimeout(() => window.open(url, '_blank'), 1500);
      }
    } catch (error) {
      console.error('Publish failed:', error);
    }
  };
  const handleDebugModeToggle = async (envType) => {
    const currentState = debugModeState[envType] ? debugModeState[envType].isEnable : false;
    const newState = !currentState;
    const heading = `Are you sure to ${
      newState ? 'enable' : 'disable'
    } debug mode for ${voca.titleCase(envType)}?`;
    const description = newState
      ? 'It will start displaying logs in the browser console window.'
      : 'It will stop displaying logs in the browser console window.';

    const result = await Swal.fire({
      title: heading,
      text: description,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: newState ? '#3085d6' : '#d33',
      cancelButtonColor: '#757f91',
      confirmButtonText: `Yes, ${newState ? 'enable' : 'disable'} it!`,
    });

    if (result.isConfirmed) {
      const newStateObject = {
        isEnable: newState,
        environment: envType,
      };

      setDebugModeState({
        ...debugModeState,
        [envType]: newStateObject,
      });
      await actions.toggleDebugMode({ projectId, version, data: newStateObject });
    }
  };

  return (
    <Modal size="lg" isOpen={popoverOpen} toggle={toggle} backdrop="static" className="publish">
      <ModalHeader toggle={toggle} className="border-bottom">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ width: '48rem' }}
        >
          <strong>Publish your app for the preview.</strong>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="row pt-2 pb-2">
          <div className="col-md-12 col-sm-12">
            <strong>Publish your app for the preview on specific environment.</strong>
            <table className="table table-stripped table-bordered table-hover table-sm">
              <thead>
                <tr>
                  <th>Server</th>
                  <th>URL</th>
                  <th>Versions</th>
                  <th>Debug</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{snakeCaseToTitleCase(PREVIEW)}</td>
                  <td>
                    <p>{generateProjectURL(domainName, seoName)}</p>
                  </td>
                  <td>
                    <select
                      className="form-control"
                      value={selVersion[PREVIEW]}
                      onChange={(event) => handleVersionChange(event, PREVIEW)}
                    >
                      <option value="">Select Version</option>
                      {versions.map((version) => (
                        <option value={version.currentVersion} key={version.currentVersion}>
                          v{version.currentVersion}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <ToggleButton
                      name="enableDebugMode"
                      bgColor="drapcode-violet"
                      onChange={() => handleDebugModeToggle(PREVIEW)}
                      isChecked={debugModeState[PREVIEW] ? debugModeState[PREVIEW].isEnable : false}
                    ></ToggleButton>
                  </td>
                  <td>
                    <div className="d-flex justify-content-center my-3">
                      <button
                        type="button"
                        className="btn btn-theme-submit btn-sm"
                        onClick={() => window.open(url)}
                      >
                        <i className="wb webconnect-eye-fill"></i>&nbsp;View
                      </button>
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-theme-submit btn-sm"
                        onClick={handlePublishClick}
                        disabled={isPreviewPublishing}
                      >
                        <i className="wb webconnect-paper-plane-fill"></i>&nbsp;Publish
                        <CustomLoader loading={isPreviewPublishing} />
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PreviewProjectModal;
